module.exports = __webpack_public_path__ + "img/aboutUs_img13.ac705c81.svg";